import { Pipe, PipeTransform } from '@angular/core';
import { TaskStatus, TaskTracking } from '@shared/models/tasks';
import { ConsolidatedTask } from '../models/task';
import { TaskTrackingStatusPipe } from './task-tracking-status.pipe';

export interface TaskFilterOptions {
  taskStatus: TaskStatus;
  searchText: string | null;
  tracking: TaskTracking[];
  tagFilterName: string | null;
}

@Pipe({
  name: 'taskFilterBy'
})
export class TaskFilterByPipe implements PipeTransform {
  transform(
    tasks: ConsolidatedTask.Model[],
    options: TaskFilterOptions
  ): ConsolidatedTask.Model[] {
    return tasks.filter(
      (t) =>
        this.doesTaskStatusMatch(t, options.taskStatus) &&
        this.doesTaskTitleMatch(t, options.searchText) &&
        this.doesTaskTrackingMatch(t, options.tracking) &&
        this.doesTaskMatchTag(t, options.tagFilterName)
    );
  }

  private doesTaskStatusMatch(
    task: ConsolidatedTask.Model,
    status: TaskStatus
  ) {
    return (
      (!task.completed && status === TaskStatus.InProgress) ||
      (task.completed && status === TaskStatus.Completed)
    );
  }

  private doesTaskTitleMatch(
    task: ConsolidatedTask.Model,
    textToSearch: string | null
  ) {
    if (!textToSearch) {
      return true;
    }
    return task.title.indexOf(textToSearch) > -1;
  }

  private doesTaskTrackingMatch(
    task: ConsolidatedTask.Model,
    tracking: TaskTracking[]
  ) {
    if (!tracking?.length || task.completed) {
      return true;
    }
    return tracking.includes(new TaskTrackingStatusPipe().transform(task.due));
  }

  private doesTaskMatchTag(
    task: ConsolidatedTask.Model,
    tagName: string | null
  ): boolean {
    if (!tagName) {
      return true;
    }
    return task.tags?.some(t => t.toLowerCase() === tagName.toLowerCase()) ?? false;
  }
}
